import React, { ReactElement, FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Typography } from 'antd'
import { BRIEF_BUILDER } from '../../../../Constants'
import { s } from './style'

const { Text, Title } = Typography

export const EmptyState: FC = (): ReactElement => {
  const { t } = useTranslation()

  return (
    <div style={s.wrapper}>
      <div style={s.root}>
        <Title level={2} style={s.header.root}>
          Welcome to <span style={s.header.smartBook}>Smart Book</span>! 👋
        </Title>
        <Text
          style={{
            fontSize: 24,
            lineHeight: '32px',
          }}>
          {t(
            'eventHub.emptyState.helpGetStarted',
            'Would you like some help getting started, or are you ready to plan something great?'
          )}
        </Text>
        <img src={require('../../../../Images/empty_state.svg')} />
        <div style={s.buttons.root}>
          <Button size='large' style={s.buttons.buttons}>
            {t('eventHub.emptyState.giveTour', 'Give me a tour')}
          </Button>
          <Button size='large' href={BRIEF_BUILDER} style={s.buttons.buttons}>
            {t('eventHub.emptyState.planEvent', 'Plan my event')}
          </Button>
        </div>
      </div>
    </div>
  )
}
